import { requestPointsProductList } from "@/api/merchant";
const points = {
  state: {
    userPoints: 0,
  },

  mutations: {
    SET_USER_POINTS: (state, userPoints) => {
      state.userPoints = userPoints;
      
    },
  },

  actions: {
    async fetchUserPoints({ commit }) {
      
        
      try {
        const res = await requestPointsProductList({});
        if (res.data && res.data.currentPoints !== undefined) {
          commit("SET_USER_POINTS", res.data.currentPoints);
        }
      } catch (error) {
        console.error("获取用户积分失败:", error);
      }
    },
  },
};

export default points;
